import { useContext } from 'react'
import { AssetLocationContext } from '@/context/AssetLocationContext'

export const useAssetLocation = () => useContext(AssetLocationContext)
